import { withRouter } from 'core/withRouter';
import { AdminDTO, AdminSearchDTO } from 'models/admin';
import React, { useEffect, useRef, useState } from 'react';
import adminService from 'services/admin.service';
import PageUtil from 'utils/Page.util';
import AdminListV from './Admin.list.v';
import PageStateService from 'core/PageState.service';

class Params {
    error: string = null;
    isLoaded: boolean = false;
    items: Array<AdminDTO>;
    total: number = 0;

    search = new AdminSearchDTO();

    searchType: string = 'name';
    keyword: string = '';
}

function AdminList(props: any) {
    const [params, setParams] = useState(new Params());
    const [search, setSearch] = useState(false);
    const stateRef = useRef(new Params());

    /* ***************************************************************************************** */
    /* ************************************* STATE ********************************************* */
    /* ***************************************************************************************** */
    useEffect(() => {
        if (!search) {
            return;
        }

        if (search) {
            setSearch(false);
            getData(params.search);
        }
    }, [search]);

    // 상태 유지
    useEffect(() => {
        stateRef.current = params as any;
    }, [params]);

    // onMount
    useEffect(() => {
        // console.log('onMount');
        const uri = location.pathname;
        let storeState = PageStateService.restorePageState(uri);

        if (storeState != null) {
            setParams(() => ({
                ...storeState,
            }));
            // console.log('onMount.storeState', storeState);
        } else {
            // console.log('LOAD FROM API');
            setSearch(true);
        }

        return () => {
            PageStateService.savePageState(uri, stateRef.current);
        };
    }, []);

    /* ***************************************************************************************** */
    /* ************************************** PAGE ********************************************* */
    /* ***************************************************************************************** */
    function onSearch() {
        const curParams = PageUtil.deepCopy(params) as Params;

        curParams.search.page = 1;
        curParams.isLoaded = false;
        curParams.search[params.searchType] = params.keyword;

        setParams(curParams);
        setSearch(true);
    }

    function onChangeRowUnit(e: any) {
        console.log('e.target.value', e.target.value);

        const search = PageUtil.deepCopy(params.search);

        search.rows = e.target.value;
        search.page = 1;

        setParams((prev) => ({
            ...prev,
            search: search,
        }));

        setSearch(true);
    }

    /* ***************************************************************************************** */
    /* ************************************* BASIC ********************************************* */
    /* ***************************************************************************************** */
    async function getData(search: AdminSearchDTO): Promise<any> {
        try {
            const res = await adminService.getList(search);
            console.log('res {getData}', res);

            const items = res.content.map((item) => {
                let roles = item.roles.map((p) => p);
                return { ...item, roles: roles };
            });

            setParams((prev) => ({
                ...prev,
                isLoaded: true,
                error: null,
                items: items,
                total: res.totalElements,
            }));
        } catch (error) {
            setParams((prev) => ({
                ...prev,
                isLoaded: true,
                error: error,
            }));

            PageUtil.handleApiError(error);
        }
    }

    /* ***************************************************************************************** */
    /* ************************************** VAC ********************************************** */
    /* ***************************************************************************************** */
    const args = {
        params: params,
        setParams: setParams,
        setSearch: setSearch,

        onSearch: onSearch,
        onChangeRowUnit: onChangeRowUnit,

        pageChanged: PageUtil.pageChanged,
        handleChange: PageUtil.handleChange,
    };

    return <AdminListV {...args} />;
}

export default withRouter(AdminList, [adminService]);
